var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import require$$0, { useState, useEffect } from "react";
import styled from "styled-components";
const ChartContainer = styled.div`
	h2.contributions-header {
		margin-bottom: 0;
	}

	.ContributionCalendar.days-selected .ContributionCalendar-day {
		opacity: 0.5;
	}

	.ContributionCalendar.days-selected .ContributionCalendar-day.active {
		opacity: 1;
	}

	.ContributionCalendar-label {
		font-size: 9px;
		fill: var(--color-text-primary);
	}

	.ContributionCalendar-day,
	.ContributionCalendar-day[data-level="0"] {
		fill: var(--color-calendar-graph-day-bg);
		shape-rendering: geometricPrecision;
		outline: 1px solid var(--color-calendar-graph-day-border);
		outline-offset: -1px;
	}

	.ContributionCalendar-day[data-level="1"] {
		fill: var(--color-calendar-graph-day-L1-bg);
		outline: 1px solid var(--color-calendar-graph-day-L1-border);
	}

	.ContributionCalendar-day[data-level="2"] {
		fill: var(--color-calendar-graph-day-L2-bg);
		outline: 1px solid var(--color-calendar-graph-day-L2-border);
	}

	.ContributionCalendar-day[data-level="3"] {
		fill: var(--color-calendar-graph-day-L3-bg);
		outline: 1px solid var(--color-calendar-graph-day-L3-border);
	}

	.ContributionCalendar-day[data-level="4"] {
		fill: var(--color-calendar-graph-day-L4-bg);
		outline: 1px solid var(--color-calendar-graph-day-L4-border);
	}

	.ContributionCalendar[data-holiday="halloween"]
		.ContributionCalendar-day[data-level="1"] {
		fill: var(--color-calendar-halloween-graph-day-L1-bg);
	}

	.ContributionCalendar[data-holiday="halloween"]
		.ContributionCalendar-day[data-level="2"] {
		fill: var(--color-calendar-halloween-graph-day-L2-bg);
	}

	.ContributionCalendar[data-holiday="halloween"]
		.ContributionCalendar-day[data-level="3"] {
		fill: var(--color-calendar-halloween-graph-day-L3-bg);
	}

	.ContributionCalendar[data-holiday="halloween"]
		.ContributionCalendar-day[data-level="4"] {
		fill: var(--color-calendar-halloween-graph-day-L4-bg);
	}

	.contributions {
		--color-calendar-graph-day-bg: #ebedf0;
		--color-calendar-graph-day-border: rgba(27, 31, 35, 0.06);
		--color-calendar-graph-day-L1-bg: #9be9a8;
		--color-calendar-graph-day-L2-bg: #40c463;
		--color-calendar-graph-day-L3-bg: #30a14e;
		--color-calendar-graph-day-L4-bg: #216e39;
		--color-calendar-graph-day-L4-border: rgba(27, 31, 35, 0.06);
		--color-calendar-graph-day-L3-border: rgba(27, 31, 35, 0.06);
		--color-calendar-graph-day-L2-border: rgba(27, 31, 35, 0.06);
		--color-calendar-graph-day-L1-border: rgba(27, 31, 35, 0.06);
		animation: fadein 1s ease-in-out;
		svg {
			cursor: default;
			max-width: 100%;
			width: 100%;
			text {
				font-size: 12px;
			}
		}
		rect:hover {
			opacity: 0.5;
		}
		.tooltip {
			animation: fadein 0.3s ease-in-out;
			font-size: 12px;
			border-radius: 2px;
			background: rgba(20, 20, 20, 0.9);
			padding: 4px 10px;
			color: #eee;
			position: fixed;
			transform: translateY(-100%) translateX(-50%);
			&:after {
				top: 100%;
				left: 50%;
				border: solid transparent;
				content: " ";
				height: 0;
				width: 0;
				position: absolute;
				pointer-events: none;
				background: transparent;
				border-top-color: rgba(20, 20, 20, 0.9);
				border-width: 5px;
				margin-left: -5px;
			}
		}
	}

	@keyframes fadein {
		from {
			opacity: 0;
		}
		to {
			opacity: 1;
		}
	}
`;
var jsxRuntime = { exports: {} };
var reactJsxRuntime_production_min = {};
/** @license React v16.14.0
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var f = require$$0, g = 60103;
reactJsxRuntime_production_min.Fragment = 60107;
if (typeof Symbol === "function" && Symbol.for) {
  var h = Symbol.for;
  g = h("react.element");
  reactJsxRuntime_production_min.Fragment = h("react.fragment");
}
var m = f.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, n = Object.prototype.hasOwnProperty, p = { key: true, ref: true, __self: true, __source: true };
function q(c, a, k) {
  var b, d = {}, e = null, l = null;
  k !== void 0 && (e = "" + k);
  a.key !== void 0 && (e = "" + a.key);
  a.ref !== void 0 && (l = a.ref);
  for (b in a)
    n.call(a, b) && !p.hasOwnProperty(b) && (d[b] = a[b]);
  if (c && c.defaultProps)
    for (b in a = c.defaultProps, a)
      d[b] === void 0 && (d[b] = a[b]);
  return { $$typeof: g, type: c, key: e, ref: l, props: d, _owner: m.current };
}
reactJsxRuntime_production_min.jsx = q;
reactJsxRuntime_production_min.jsxs = q;
{
  jsxRuntime.exports = reactJsxRuntime_production_min;
}
const jsx = jsxRuntime.exports.jsx;
const jsxs = jsxRuntime.exports.jsxs;
const Loader = () => {
  return /* @__PURE__ */ jsx("div", {
    style: {
      textAlign: "center",
      margin: "4em auto"
    },
    children: /* @__PURE__ */ jsxs("svg", {
      width: "40",
      height: "40",
      viewBox: "0 0 105 105",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "#777",
      children: [/* @__PURE__ */ jsx("circle", {
        cx: "12.5",
        cy: "12.5",
        r: "12.5",
        children: /* @__PURE__ */ jsx("animate", {
          attributeName: "fill-opacity",
          begin: "0s",
          dur: "1s",
          values: "1;.2;1",
          calcMode: "linear",
          repeatCount: "indefinite"
        })
      }), /* @__PURE__ */ jsx("circle", {
        cx: "12.5",
        cy: "52.5",
        r: "12.5",
        fillOpacity: ".5",
        children: /* @__PURE__ */ jsx("animate", {
          attributeName: "fill-opacity",
          begin: "100ms",
          dur: "1s",
          values: "1;.2;1",
          calcMode: "linear",
          repeatCount: "indefinite"
        })
      }), /* @__PURE__ */ jsx("circle", {
        cx: "52.5",
        cy: "12.5",
        r: "12.5",
        children: /* @__PURE__ */ jsx("animate", {
          attributeName: "fill-opacity",
          begin: "300ms",
          dur: "1s",
          values: "1;.2;1",
          calcMode: "linear",
          repeatCount: "indefinite"
        })
      }), /* @__PURE__ */ jsx("circle", {
        cx: "52.5",
        cy: "52.5",
        r: "12.5",
        children: /* @__PURE__ */ jsx("animate", {
          attributeName: "fill-opacity",
          begin: "600ms",
          dur: "1s",
          values: "1;.2;1",
          calcMode: "linear",
          repeatCount: "indefinite"
        })
      }), /* @__PURE__ */ jsx("circle", {
        cx: "92.5",
        cy: "12.5",
        r: "12.5",
        children: /* @__PURE__ */ jsx("animate", {
          attributeName: "fill-opacity",
          begin: "800ms",
          dur: "1s",
          values: "1;.2;1",
          calcMode: "linear",
          repeatCount: "indefinite"
        })
      }), /* @__PURE__ */ jsx("circle", {
        cx: "92.5",
        cy: "52.5",
        r: "12.5",
        children: /* @__PURE__ */ jsx("animate", {
          attributeName: "fill-opacity",
          begin: "400ms",
          dur: "1s",
          values: "1;.2;1",
          calcMode: "linear",
          repeatCount: "indefinite"
        })
      }), /* @__PURE__ */ jsx("circle", {
        cx: "12.5",
        cy: "92.5",
        r: "12.5",
        children: /* @__PURE__ */ jsx("animate", {
          attributeName: "fill-opacity",
          begin: "700ms",
          dur: "1s",
          values: "1;.2;1",
          calcMode: "linear",
          repeatCount: "indefinite"
        })
      }), /* @__PURE__ */ jsx("circle", {
        cx: "52.5",
        cy: "92.5",
        r: "12.5",
        children: /* @__PURE__ */ jsx("animate", {
          attributeName: "fill-opacity",
          begin: "500ms",
          dur: "1s",
          values: "1;.2;1",
          calcMode: "linear",
          repeatCount: "indefinite"
        })
      }), /* @__PURE__ */ jsx("circle", {
        cx: "92.5",
        cy: "92.5",
        r: "12.5",
        children: /* @__PURE__ */ jsx("animate", {
          attributeName: "fill-opacity",
          begin: "200ms",
          dur: "1s",
          values: "1;.2;1",
          calcMode: "linear",
          repeatCount: "indefinite"
        })
      })]
    })
  });
};
const GithubContributions = ({
  username
}) => {
  const [state, setState] = useState({
    loaded: false,
    error: false,
    chart: "",
    header: ""
  });
  const [tooltip, setTooltip] = useState({
    position: null,
    data: null
  });
  const handleMouseOver = (e) => {
    var _a;
    if ((_a = e == null ? void 0 : e.target) == null ? void 0 : _a.matches("rect")) {
      const rect = e.target.getBoundingClientRect();
      setTooltip({
        data: e.target.dataset,
        position: {
          left: rect.x + rect.width / 2,
          top: rect.y - 4
        }
      });
    }
  };
  const handleMouseOut = () => {
    setTooltip(null);
  };
  const init = async () => {
    var _a, _b;
    try {
      const contributions = await fetch(`https://cors.kylekarpack.workers.dev/corsproxy/?apiurl=https://github.com/users/${username}/contributions`, {
        mode: "cors"
      });
      let responseText = await contributions.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(responseText, "text/html");
      const graph = doc.body.querySelector(".calendar-graph, .js-calendar-graph");
      (_a = graph.querySelector(".f6")) == null ? void 0 : _a.remove();
      (_b = graph.querySelector(".width-full > .float-right")) == null ? void 0 : _b.remove();
      const svg = graph.querySelector("svg");
      svg.setAttribute("viewBox", `0 0 ${svg.getAttribute("width") || "828"} ${svg.getAttribute("height") || "128"}`);
      setState(__spreadProps(__spreadValues({}, state), {
        loaded: true,
        header: doc.body.querySelector(".f4").innerHTML,
        chart: graph.innerHTML
      }));
    } catch (e) {
      setState(__spreadProps(__spreadValues({}, state), {
        error: true,
        loaded: true
      }));
      console.warn("Error retrieving graph: ", e);
    }
  };
  useEffect(() => {
    typeof window !== "undefined" && window.addEventListener("scroll", handleMouseOut);
    return () => {
      typeof window !== "undefined" && window.removeEventListener("scroll", handleMouseOut);
    };
  }, []);
  useEffect(() => {
    init();
  }, [username]);
  if (!state.loaded) {
    return /* @__PURE__ */ jsx(Loader, {});
  }
  return /* @__PURE__ */ jsx(ChartContainer, {
    children: /* @__PURE__ */ jsxs("div", {
      className: "contributions",
      children: [state.error ? /* @__PURE__ */ jsx("div", {
        children: "Sorry, we couldn't load these contributions right now"
      }) : "", /* @__PURE__ */ jsx("h2", {
        className: "contributions-header",
        children: state.header
      }), /* @__PURE__ */ jsx("div", {
        className: "contributions-chart",
        onMouseOver: handleMouseOver,
        onMouseOut: handleMouseOut,
        dangerouslySetInnerHTML: {
          __html: state.chart
        }
      }), tooltip && tooltip.data ? /* @__PURE__ */ jsxs("div", {
        className: "tooltip",
        style: tooltip.position,
        children: [/* @__PURE__ */ jsx("strong", {
          children: "Date:"
        }), " ", tooltip.data.date, " ", /* @__PURE__ */ jsx("br", {}), /* @__PURE__ */ jsx("strong", {
          children: "Contributions:"
        }), " ", tooltip.data.count]
      }) : ""]
    })
  });
};
export { GithubContributions, GithubContributions as default };
